export default "__VITE_ASSET__DBU4d3AF__"